import _Defaults from "./versions/v1/Defaults";
import _Validator from "./versions/v1/Validator";
import _Defaults2 from "./versions/v2/Defaults";
import _Validator2 from "./versions/v2/Validator";
import _Converter from "./versions/v2/Converter";
import _Defaults3 from "./versions/v3/Defaults";
import _Validator3 from "./versions/v3/Validator";
import _Converter2 from "./versions/v3/Converter";
import _Defaults4 from "./versions/v3_1/Defaults";
import _Validator4 from "./versions/v3_1/Validator";
import _Converter3 from "./versions/v3_1/Converter";
import _Defaults5 from "./versions/v3_2/Defaults";
import _Validator5 from "./versions/v3_2/Validator";
import _Converter4 from "./versions/v3_2/Converter";
import _Defaults6 from "./versions/v3_3/Defaults";
import _Validator6 from "./versions/v3_3/Validator";
import _Converter5 from "./versions/v3_3/Converter";
import _Defaults7 from "./versions/v3_4/Defaults";
import _Validator7 from "./versions/v3_4/Validator";
import _Converter6 from "./versions/v3_4/Converter";
import _Defaults8 from "./versions/v4_0/Defaults";
import _Validator8 from "./versions/v4_0/Validator";
import _Converter7 from "./versions/v4_0/Converter";
import _Defaults9 from "./versions/v4_1/Defaults";
import _Validator9 from "./versions/v4_1/Validator";
import _Converter8 from "./versions/v4_1/Converter";
import _Defaults10 from "./versions/v5/Defaults";
import _Validator10 from "./versions/v5/Validator";
import _Converter9 from "./versions/v5/Converter";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latestVersion = exports.evaluateSettingsVersion = exports.validate = exports.convert = exports.previousVersion = exports.Defaults = exports.DefaultsV5 = exports.DefaultsV4_1 = exports.DefaultsV4_0 = exports.DefaultsV3_4 = exports.DefaultsV3_3 = exports.DefaultsV3_2 = exports.DefaultsV3_1 = exports.DefaultsV3 = exports.DefaultsV2 = exports.DefaultsV1 = void 0;
const Defaults_1 = _Defaults;
Object.defineProperty(exports, "DefaultsV1", {
  enumerable: true,
  get: function () {
    return Defaults_1.Defaults;
  }
});
const Validator_1 = _Validator;
const Defaults_2 = _Defaults2;
Object.defineProperty(exports, "DefaultsV2", {
  enumerable: true,
  get: function () {
    return Defaults_2.Defaults;
  }
});
const Validator_2 = _Validator2;
const Converter_1 = _Converter;
const Defaults_3 = _Defaults3;
Object.defineProperty(exports, "DefaultsV3", {
  enumerable: true,
  get: function () {
    return Defaults_3.Defaults;
  }
});
const Validator_3 = _Validator3;
const Converter_2 = _Converter2;
const Defaults_4 = _Defaults4;
Object.defineProperty(exports, "DefaultsV3_1", {
  enumerable: true,
  get: function () {
    return Defaults_4.Defaults;
  }
});
const Validator_4 = _Validator4;
const Converter_3 = _Converter3;
const Defaults_5 = _Defaults5;
Object.defineProperty(exports, "DefaultsV3_2", {
  enumerable: true,
  get: function () {
    return Defaults_5.Defaults;
  }
});
const Validator_5 = _Validator5;
const Converter_4 = _Converter4;
const Defaults_6 = _Defaults6;
Object.defineProperty(exports, "DefaultsV3_3", {
  enumerable: true,
  get: function () {
    return Defaults_6.Defaults;
  }
});
const Validator_6 = _Validator6;
const Converter_5 = _Converter5;
const Defaults_7 = _Defaults7;
Object.defineProperty(exports, "DefaultsV3_4", {
  enumerable: true,
  get: function () {
    return Defaults_7.Defaults;
  }
});
const Validator_7 = _Validator7;
const Converter_6 = _Converter6;
const Defaults_8 = _Defaults8;
Object.defineProperty(exports, "DefaultsV4_0", {
  enumerable: true,
  get: function () {
    return Defaults_8.Defaults;
  }
});
const Validator_8 = _Validator8;
const Converter_7 = _Converter7;
const Defaults_9 = _Defaults9;
Object.defineProperty(exports, "DefaultsV4_1", {
  enumerable: true,
  get: function () {
    return Defaults_9.Defaults;
  }
});
const Validator_9 = _Validator9;
const Converter_8 = _Converter8;
const Defaults_10 = _Defaults10;
Object.defineProperty(exports, "DefaultsV5", {
  enumerable: true,
  get: function () {
    return Defaults_10.Defaults;
  }
});
Object.defineProperty(exports, "Defaults", {
  enumerable: true,
  get: function () {
    return Defaults_10.Defaults;
  }
});
const Validator_10 = _Validator10;
const Converter_9 = _Converter9;
exports.previousVersion = ["1.0", "2.0", "3.0", "3.1", "3.2", "3.3", "3.4", "4.0", "4.1"];
let settingsUtilities = [];
settingsUtilities.push({
  version: "1.0",
  defaults: Defaults_1.Defaults,
  convertToPrevious: s => s,
  convertFromPrevious: s => s,
  validate: Validator_1.validate
});
settingsUtilities.push({
  version: "2.0",
  defaults: Defaults_2.Defaults,
  convertToPrevious: Converter_1.convertToPrevious,
  convertFromPrevious: Converter_1.convertFromPrevious,
  validate: Validator_2.validate
});
settingsUtilities.push({
  version: "3.0",
  defaults: Defaults_3.Defaults,
  convertToPrevious: Converter_2.convertToPrevious,
  convertFromPrevious: Converter_2.convertFromPrevious,
  validate: Validator_3.validate
});
settingsUtilities.push({
  version: "3.1",
  defaults: Defaults_4.Defaults,
  convertToPrevious: Converter_3.convertToPrevious,
  convertFromPrevious: Converter_3.convertFromPrevious,
  validate: Validator_4.validate
});
settingsUtilities.push({
  version: "3.2",
  defaults: Defaults_5.Defaults,
  convertToPrevious: Converter_4.convertToPrevious,
  convertFromPrevious: Converter_4.convertFromPrevious,
  validate: Validator_5.validate
});
settingsUtilities.push({
  version: "3.3",
  defaults: Defaults_6.Defaults,
  convertToPrevious: Converter_5.convertToPrevious,
  convertFromPrevious: Converter_5.convertFromPrevious,
  validate: Validator_6.validate
});
settingsUtilities.push({
  version: "3.4",
  defaults: Defaults_7.Defaults,
  convertToPrevious: Converter_6.convertToPrevious,
  convertFromPrevious: Converter_6.convertFromPrevious,
  validate: Validator_7.validate
});
settingsUtilities.push({
  version: "4.0",
  defaults: Defaults_8.Defaults,
  convertToPrevious: Converter_7.convertToPrevious,
  convertFromPrevious: Converter_7.convertFromPrevious,
  validate: Validator_8.validate
});
settingsUtilities.push({
  version: "4.1",
  defaults: Defaults_9.Defaults,
  convertToPrevious: Converter_8.convertToPrevious,
  convertFromPrevious: Converter_8.convertFromPrevious,
  validate: Validator_9.validate
});
settingsUtilities.push({
  version: "5.0",
  defaults: Defaults_10.Defaults,
  convertToPrevious: Converter_9.convertToPrevious,
  convertFromPrevious: Converter_9.convertFromPrevious,
  validate: Validator_10.validate
});
const convert = (settings, targetVersion) => {
  const original_version = settings.settings_version || "1.0";
  if (original_version === targetVersion) return settings;
  const target = settingsUtilities.findIndex(util => {
    return util.version === targetVersion;
  });
  const current = settingsUtilities.findIndex(util => {
    return util.version === original_version;
  });
  if (target === -1) throw new Error("ViewerSettings.convert: Target version not available");
  if (current === -1) throw new Error("ViewerSettings.convert: Settings version not available");
  let tempSettings = settings;
  if (target < current) {
    for (let i = current; target < i; i--) tempSettings = settingsUtilities[i].convertToPrevious(tempSettings, original_version);
  } else {
    for (let i = current + 1; i <= target; i++) tempSettings = settingsUtilities[i].convertFromPrevious(tempSettings, original_version);
  }
  return tempSettings;
};
exports.convert = convert;
const validate = (settings, targetVersion) => {
  const settings_version = settings.settings_version || "1.0";
  if (targetVersion !== undefined) {
    const index = settingsUtilities.findIndex(util => {
      return util.version === targetVersion;
    });
    if (index === -1) throw new Error("ViewerSettings.validate: Target version was not found.");
    if (settings_version !== undefined && settings_version !== targetVersion) throw new Error("ViewerSettings.validate: The settings do have a different version than the target version.");
    settingsUtilities[index].validate(settings);
  } else {
    if (!settings_version) throw new Error("ViewerSettings.validate: Settings do not have a version specified.");
    const index = settingsUtilities.findIndex(util => {
      return util.version === settings_version;
    });
    settingsUtilities[index].validate(settings);
  }
};
exports.validate = validate;
const evaluateSettingsVersion = viewerVersion => {
  if (!viewerVersion || viewerVersion.startsWith("1")) return "1.0";
  if (viewerVersion.startsWith("2")) {
    const upgradeVersions = viewerVersion.split(".").map(item => {
      var _a;
      return (_a = item.match(/^\d+/)) === null || _a === void 0 ? void 0 : _a[0];
    }).filter(Boolean).map(match => parseInt(match));
    if (upgradeVersions[1] >= 18) {
      return "2.0";
    } else {
      return "1.0";
    }
  }
  if (viewerVersion.startsWith("3")) {
    const upgradeVersions = viewerVersion.split(".").map(item => {
      var _a;
      return (_a = item.match(/^\d+/)) === null || _a === void 0 ? void 0 : _a[0];
    }).filter(Boolean).map(match => parseInt(match));
    if (upgradeVersions[1] >= 3) {
      return "5.0";
    } else if (upgradeVersions[1] === 2 && upgradeVersions[2] >= 11 || upgradeVersions[1] > 2) {
      return "4.1";
    } else if (upgradeVersions[1] === 2 && upgradeVersions[2] >= 10 || upgradeVersions[1] > 2) {
      return "4.0";
    } else if (upgradeVersions[1] === 2 && upgradeVersions[2] >= 9 || upgradeVersions[1] > 2) {
      return "3.4";
    } else if (upgradeVersions[1] === 2 && upgradeVersions[2] >= 7 || upgradeVersions[1] > 2) {
      return "3.3";
    } else if (upgradeVersions[1] === 2 && upgradeVersions[2] >= 6 || upgradeVersions[1] > 2) {
      return "3.2";
    } else if (upgradeVersions[1] === 1 && upgradeVersions[2] >= 12 || upgradeVersions[1] > 1) {
      return "3.1";
    } else {
      return "3.0";
    }
  }
  return "1.0";
};
exports.evaluateSettingsVersion = evaluateSettingsVersion;
exports.latestVersion = "5.0";
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  latestVersion = exports.latestVersion,
  previousVersion = exports.previousVersion,
  Defaults = exports.Defaults,
  DefaultsV5 = exports.DefaultsV5,
  DefaultsV4_1 = exports.DefaultsV4_1,
  DefaultsV4_0 = exports.DefaultsV4_0,
  DefaultsV3_4 = exports.DefaultsV3_4,
  DefaultsV3_3 = exports.DefaultsV3_3,
  DefaultsV3_2 = exports.DefaultsV3_2,
  DefaultsV3_1 = exports.DefaultsV3_1,
  DefaultsV3 = exports.DefaultsV3,
  DefaultsV2 = exports.DefaultsV2,
  DefaultsV1 = exports.DefaultsV1;
const _evaluateSettingsVersion = exports.evaluateSettingsVersion,
  _validate = exports.validate,
  _convert = exports.convert;
export { _evaluateSettingsVersion as evaluateSettingsVersion, _validate as validate, _convert as convert };